import baseRoute from '../baseRoute';

export type * from './viewModel';

type RouteDefinition = `${typeof baseRoute}/fieldReportTypes/findAllForCompany`;

export const ROUTE: RouteDefinition = `${baseRoute}/fieldReportTypes/findAllForCompany`;

export const URL = (): RouteDefinition => `${baseRoute}/fieldReportTypes/findAllForCompany`;
